import type { HttpRequestCancelToken } from '@core/HttpRequestCancelToken'
import { isEmpty } from 'lodash'
import type { AppCategory } from '@core/application/ApplicationConstants'

export interface SearchResultListItem {
  filename: string
  highlight: string
  size: number
  absolutePath: string
  id: string
  lastModified: number
  type: number
  storageType?: number
  relativePath?: string
  source?: string
  _filename?: string
  active?: boolean
}

export interface SearchResponseData {
  provider: SearchResultProvider
  list: SearchResultListItem[]
}

export interface SearchResultProvider {
  source: AppCategory
  sourceName: string | undefined
  name: string
  id: string
  isConnected?: boolean
  appId: string
}

export abstract class SearchProvider {
  _id = ''
  _name = ''
  _source = 0
  _sourceName: string | undefined
  _list: SearchResultListItem[] = []
  _appId = ''
  #pages = 1
  #currentPageNum = 1
  hasMorePages = true
  _requestCancelToken: HttpRequestCancelToken | undefined

  get currentPageNum() {
    return this.#currentPageNum
  }

  abstract init(searchValue: string): void

  abstract search(): Promise<void>

  async #cancel(): Promise<void> {
    try {
      this._requestCancelToken?.cancel()
      this._requestCancelToken = undefined
    } catch (error) {
      //TODO: handle error
      console.error(error)
    }
  }

  #reset() {
    this._list = []
    this.hasMorePages = true
    this.#currentPageNum = 1
  }

  abstract destroy(): Promise<void>

  async _clean() {
    await this.#cancel()
    this.#reset()
  }

  getSearchResult(): SearchResponseData[] {
    let assemblyList: SearchResponseData[] = []

    assemblyList = [
      {
        provider: {
          source: this._source,
          name: this._name,
          id: this._id,
          sourceName: this._sourceName,
          appId: this._appId,
        },
        list: this._list,
      },
    ]

    return assemblyList
  }

  _setInfo(list: SearchResultListItem[] | undefined, pages: number | undefined) {
    if (list) {
      this._list = [...this._list, ...list]
    }
    this.#pages = pages || 1

    if (this.#pages > this.#currentPageNum) {
      this.#currentPageNum++
    } else if (this.#pages === this.#currentPageNum || isEmpty(this._list)) {
      // 翻到底页或list没有数据时noMorePages
      this.hasMorePages = false
    }
  }
}
